'use client';

import { useState, useEffect } from 'react';
import { useParams } from 'next/navigation';
import { contentSectionAPI } from '@/services/api';
import Head from 'next/head';
import Footer from '../../../components/Footer';

export default function PublicContentPage() {
  const params = useParams();
  const name = params.name;
  const [contentPage, setContentPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pageNotFound, setPageNotFound] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchContentPage();
  }, [name]);

  const fetchContentPage = async () => {
    try {
      setLoading(true);
      setError(null);
      console.log('Fetching content page with name:', name);
      const response = await contentSectionAPI.getContentSectionByName(name);
      console.log('API response:', response);
      if (response && response.isActive) {
        setContentPage(response);
        setPageNotFound(false);
      } else {
        setPageNotFound(true);
      }
    } catch (error) {
      console.error('Error fetching content page:', error);
      setError(error.message);
      setPageNotFound(true);
    } finally {
      setLoading(false);
    }
  };

  if (pageNotFound) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-md text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Page Not Found</h1>
          <p className="text-gray-600 mb-4">The page you are looking for does not exist or is not active.</p>
          <a
            href="/"
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
          >
            Go Home
          </a>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-md text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Error Loading Page</h1>
          <p className="text-gray-600 mb-4">Error: {error}</p>
          <a
            href="/"
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
          >
            Go Home
          </a>
        </div>
      </div>
    );
  }

  return (<>
    <div className="min-h-screen bg-gray-50">
      <Head>
        <title>{contentPage?.sectionName || 'Content Page'} | Bus Ticketing System</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        {contentPage && (
          <meta name="description" content={contentPage.sectionName} />
        )}
      </Head>

      <main className="py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="flex justify-center items-center py-12">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
          ) : contentPage ? (
            <div className="bg-white shadow overflow-hidden sm:rounded-lg">
              <div className="px-4 py-5 sm:p-6">
                <h1 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate mb-6">
                  {contentPage.sectionName}
                </h1>
                
                <div className="prose max-w-none">
                  <div dangerouslySetInnerHTML={{ __html: contentPage.content || '<p>No content available</p>' }} />
                </div>
              </div>
            </div>
          ) : (
            <div className="flex justify-center items-center py-12">
              <p className="text-gray-600">No content available</p>
            </div>
          )}
        </div>
      </main>
    </div>
    <Footer />
    </>
  );
}